import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';
import { Location } from '@angular/common';
import { EventService } from 'src/app/services/event.service';
import { getParamWithoutCookie, languages } from 'src/app/shared/constants/app-enums';
import { selectedLang } from 'src/app/app.component';
import { WalletConnectService } from 'src/app/services/wallet-connect.service';
import { ConnectComponent } from 'src/app/modals/connect/connect.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements AfterViewInit, OnInit, AfterViewInit {

  @ViewChild('navigation') navigation!: ElementRef;
  @ViewChild('launchTime', { static: false }) elRef!: ElementRef;

  isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024
  isScrolled: boolean = false;
  showMenu: boolean = false;
  openMenu: boolean = false;
  modalRef?: BsModalRef;
  hashKey: string = '';
  windowSize: number;
  currentLanguage: any;
  languagesList: Array<any> = languages;
  selectedLanguage: any;
  isShimmer: boolean = true;
  isRotated: boolean = false;
  isExpand: boolean = true;
  showBW: boolean = false;
  daysUntilBurn = 0;
  targetDate: Date = new Date();
  currentDate!: Date;
  // countDownTimer:any;

  navigations: Array<any> = [
    {
      routeName: 'commission',
      navName: 'commission',
    },

    {
      routeName: 'why-us',
      navName: 'nav-why-us',
    },
    {
      routeName: 'faqs',
      navName: 'faq_head',
    },
    {
      routeName: 'contact',
      navName: 'nav_contact',
    },
  ];


  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isScrolled = window.pageYOffset >= 100;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.windowSize = event.target.innerWidth;
    this.isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024
  }

  liveCounter: any;

  constructor(
    private location: Location,
    private eventService: EventService,
    private translate: TranslateService,
    private modalService: BsModalService,
    private walletConnectService: WalletConnectService
  ) {
    // this.setTargetDate();
    // setInterval(() => {
    //   // Check if current time has passed the target time
    //   this.currentDate = new Date();
    //   if (this.currentDate.getTime() > this.targetDate.getTime()) {
    //     // this.setTargetDate(2);
    //     this.setTargetDate();
    //   }
    // }, 1000);
    
  //   this.eventService.getCounter().subscribe((val) => {
  //     this.liveCounter = val;
  //  });

    this.walletConnectService.activateSite();
    this.windowSize = window.screen.width;
    this.eventService.getLang().subscribe((val: any) => {
      this.currentLanguage = val || 'en';
      this.selectedLanguage = this.languagesList.filter(
        (x) => x.value === this.currentLanguage
      )[0];
    });
  }

  // setTargetDate(nextMonthCount: number = 1) {
  //   this.targetDate.setUTCMonth(this.targetDate.getUTCMonth() + nextMonthCount, 2);
  //   // this.targetDate.setUTCDate(this.targetDate.getUTCDate() - 1);
  //   this.targetDate.setUTCHours(18, 0, 1, 0);
  //   this.eventService.setCounter(this.targetDate.getTime());
  // }

  get walletAddress(): any {
    return this.walletConnectService.walletAddress;
  }


  ngOnInit(): void {
    if (!this.currentLanguage) {
      this.currentLanguage = selectedLang;
      this.selectedLanguage = this.languagesList.filter(
        (x) => x.value === this.currentLanguage
      )[0];
    }
    setTimeout(() => (this.isShimmer = false), 2000);
  }

  ngAfterViewInit(): void {
    if (window.location.hash) {
      setTimeout(() => {
        this.hashKey = window.location.hash.substring(1, window.location.hash.length);
        console.log('window.location.hash', this.hashKey)
        this.eventService.scrollToFn(this.hashKey);
      }, 2000);
    }

    const bwUrl = getParamWithoutCookie('bwUrl');
    if (bwUrl && bwUrl != '') {
      this.showBW = true;
    }

    // setInterval(() => {
    //   this.daysUntilBurn = Math.floor((this.targetTime - new Date().getTime()) / (1000 * 60 * 60 * 24) + 1);
    // }, 1000);
  }

  openCloseMenu(): void {
    if (this.showMenu) {
      this.openMenu = !this.openMenu;
      setTimeout(() => (this.showMenu = !this.showMenu), 200);
    } else {
      this.showMenu = !this.showMenu;
      setTimeout(() => (this.openMenu = !this.openMenu), 200);
    }
  }

  changeLanguage(requestLang: any): void {
    this.currentLanguage = requestLang;
    this.translate.use(this.currentLanguage);
    this.eventService.setLang(this.currentLanguage);
    this.selectedLanguage = this.languagesList.filter((x) => x.value === this.currentLanguage)[0];
    this.replaceURL();
  }

  replaceURL(): void {
    const current_url = this.location.path().split('/');
    current_url.shift();
    // console.log('current_url', current_url)
    current_url.splice(0, 1, this.currentLanguage);
    const new_url = current_url.join('/');
    this.hashKey = window.location.hash || '';
    // console.log('new_url', new_url)
    this.location.replaceState('/' + new_url + this.hashKey);
  }

  connectModal(): void {
    if (!this.walletAddress) {
      setTimeout(() => {
        this.modalRef = this.modalService.show(ConnectComponent, {
          class: 'modal-min modal-dialog-centered',
          backdrop: 'static',
        });
      }, 1000);
    }
  }

  disconnect() {
    this.walletConnectService.disConnectWallet();
  }

  connectBestWallet() {
    window.scroll({ top: 10 });
    this.walletConnectService.connectWallet("bw");
  }

  get isDashboard() {
    return (window.location.pathname == "/" + this.currentLanguage + "/dashboard")
      || (window.location.pathname == "/" + this.currentLanguage);
  }

  get isTokenPage() {
    return (window.location.pathname == "/" + this.currentLanguage + "/token")
  }
}
